export default __webpack_public_path__ + "static/media/wapha-logo-white-label.fd68082f.svg";